export const Solar = {
    sun :    {key:'sun',     path: 'assets/solar/sun.png'},
    mercury: {key:'mercury', path: 'assets/solar/mercury.png'},
    venus:   {key:'venus',   path: 'assets/solar/venus.png'},
    earth:   {key:'earth',   path: 'assets/solar/earth.png'},
    moon:    {key:'moon',    path: 'assets/solar/moon.png'},
    mars:    {key:'mars',    path: 'assets/solar/mars.png'},
    jupiter: {key:'jupiter', path: 'assets/solar/jupiter.png'},
    saturn:  {key:'saturn',  path: 'assets/solar/saturn.png'},
    uranus:  {key:'uranus',  path: 'assets/solar/uranus.png'},
    neptune: {key:'neptune', path: 'assets/solar/neptune.png'},
    pluto:   {key:'pluto',   path: 'assets/solar/pluto.png'},
};